<div class="row sub-footer" >
  <div class="col-8 col-md-8 col-lg-10 mx-auto text-center">
    <p><font size="-1" color="#fff"><strong>750 Lexington Ave. 6th Floor New York, NY 10022® I Draw LLC – 2025 – All rights reserved.</strong></font></p><br>
    <font size="-1" color="#fff">*I Draw LLC does not perform a hard credit pull at any point in our process, for SBA LOANS a hard pull may be required at the time of funding.  You will be notified in advance of this taking place. 2 Rates shown vary based on product, credit determination, state law/minimum loan amounts and lender criteria. Not all applicants will qualify for financing, all loans are subject to credit review and lender approval. 3 We provide business financing as a direct lender or through a network of unaffiliated third-party banks and funding providers.</font>
  </div>
</div>



